import Vue from 'vue'
import Index from './index.vue'
import Router from 'vue-router'
import "babel-polyfill";
import preview from 'vue-photo-preview'
import store from '@/store/index.js'
import 'vue-photo-preview/dist/skin.css'
import { getQueryString } from '@/scripts/util.js'
import { bpoTip } from '@/scripts/bpo.js'

Vue.use(preview, {
    fullscreenEl: false //关闭全屏幕展示
});
Vue.use(Router);
const router = new Router({
    // mode: 'history',
    routes: [{
        path: '/',
        component: resolve => require(['./children/overview.vue'], resolve),
        name: 'center',
        redirect: '/overview'
    }, {
        path: '/overview',
        component: resolve => require(['./children/overview.vue'], resolve),
        name: 'overview',
    }, {
        path: '/customers',
        component: resolve => require(['./children/customers.vue'], resolve),
        name: 'customers',
    }, {
        path: '/filialeCustomer',
        component: resolve => require(['./children/filialeCustomer.vue'], resolve),
        name: 'filialeCustomer',
    }, {
        path: '/activity',
        component: resolve => require(['./children/activity.vue'], resolve),
        name: 'activity',
    }, {
        path: '/team',
        component: resolve => require(['./children/team.vue'], resolve),
        name: 'team',
    }, {
        path: '/customerOrder',
        component: resolve => require(['./children/customerOrder.vue'], resolve),
        name: 'customerOrder',
    }, {
        path: '/filialeCustomerOrder',
        component: resolve => require(['./children/filialeCustomerOrder.vue'], resolve),
        name: 'filialeCustomerOrder',
    }, {
        path: '/realName',
        component: resolve => require(['./children/realName.vue'], resolve),
        name: 'realName',
    }, {
        path: '/contract',
        component: resolve => require(['./children/contract.vue'], resolve),
        name: 'contract',
    }, {
        path: '/serviceCertificate',
        component: resolve => require(['./children/serviceCertificate.vue'], resolve),
        name: 'serviceCertificate',
    }, {
        path: '/serviceSiteInfo',
        component: resolve => require(['./children/serviceSiteInfo.vue'], resolve),
        name: 'serviceSiteInfo',
    }, {
        path: '/addressManage',
        component: resolve => require(['./children/addressManage.vue'], resolve),
        name: 'addressManage',
    }, {
        path: '/discountCoupon',
        component: resolve => require(['@/pages/personalCenter/children/discountCoupon.vue'], resolve),
        name: 'discountCoupon',
    }, {
        path: '/couponRecord',
        component: resolve => require(['@/pages/personalCenter/children/couponRecord.vue'], resolve),
        name: 'couponRecord',
    }, {
        path: '/suppliedCoupon',
        component: resolve => require(['@/pages/personalCenter/children/suppliedCoupon.vue'], resolve),
        name: 'suppliedCoupon',
    }, ]
})
Vue.config.productionTip = false
Vue.prototype.$toast = bpoTip;
Vue.prototype.$query = getQueryString;
Vue.filter('formatPrice', function(value) {
    var num = 0;
    if (!isNaN(Number(value))) {
        num = Number(value);
    }
    return num.toFixed(2);
})
new Vue({
    render: h => h(Index),
    router,
    store,
}).$mount('#app')